import EmptyState from '@/components/EmptyState';
import { BellIcon } from '@/icons';
import { Card } from 'antd';
import type { LastActionData } from '../../../../../../app/features/employee/emp-dashboard/emp-dashboard.type';

interface BreakNotificationsCardProps {
  lastActionStats?: LastActionData[];
  isLoading?: boolean;
}

export default function BreakNotificationsCard({
  lastActionStats,
  isLoading = false,
}: BreakNotificationsCardProps) {
  return (
    <>
      <Card
        className="dark:bg-theme-slate-800 border dark:border-theme-gray-700 rounded-2xl w-full max-w-5xl mx-auto"
        styles={{ body: { padding: '24px' } }}
        loading={isLoading}
      >
        {/* Scrollable List */}
        <div className="space-y-5 max-h-[415px] overflow-y-auto pr-2 custom-scroll">
          {lastActionStats && lastActionStats.length > 0 ? (
            lastActionStats.map((item) => (
              <div
                key={item.userId + item.timestamp}
                className="
                bg-[#0F172A]
                p-3
                rounded-xl
                relative
                border-l-2 border-teal-500"
              >
                <div className="flex justify-between items-center">
                  <div className="text-white text-lg font-medium">
                    {item.name}
                  </div>
                  <div className=" text-white text-sm font-normal">
                    Department :{' '}
                    <span className="font-semibold text-sm text-white">
                      {item.department}
                    </span>
                  </div>
                </div>

                <p className="text-neutral-400 text-base font-medium mt-1">
                  {item.designation}
                </p>

                <p className="text-white text-base font-medium mt-1">
                  {item.message}
                </p>
              </div>
            ))
          ) : (
            <EmptyState
              className="py-5"
              icon={<BellIcon size={36} />}
              title="No Recent Activity"
              description="Employee break and check-in/out notifications will appear here as they occur throughout the day."
            />
          )}
        </div>
      </Card>
    </>
  );
}
